import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './jquery'
import './global-functions'
import './heading-anchors'
import '../scss/index.scss'
import './bootstrap'
import './layouts'
import './partials'
import './components'
// import './theme-debug'
